import { Controller } from "@hotwired/stimulus"
import { Modal } from "flowbite"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["action"]

  connect() {
    this.modal = new Modal(this.element, {
      backdropClasses: 'bg-transparent fixed inset-0 z-52'
    })

    this.element.addEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))
    document.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))

    document.addEventListener("modal:show", this.show.bind(this))
    document.addEventListener("modal:hide", this.hide.bind(this))

    this.triggeredFileInputId = null
  }

  handleFrameLoad(event) {
    if (event.target) {
      const frameId = event.target.id

      if (frameId === "modal_content") {
        const triggeringForm = document.querySelector('[data-triggered-input-id]')
        if (triggeringForm) {
          this.triggeredFileInputId = triggeringForm.dataset.triggeredInputId
        }

        this.modal.show()
      }
    }
  }

  handleSubmitEnd(event) {
    const formElement = event.target;
    const actionInput = formElement.querySelector('input[data-action-target]');

    if (actionInput && actionInput.value === "skip") {
      return;
    }

    if (event.detail.fetchResponse?.response.ok) {
      this.hide()
    }
  }

  hide() {
    this.modal.hide()
    const turboFrame = document.getElementById("modal_content")
    if (turboFrame) {
      turboFrame.innerHTML = ""
    }

    if (this.triggeredFileInputId) {
      const fileInput = document.getElementById(this.triggeredFileInputId)
      if (fileInput) {
        fileInput.value = ""
      }
      this.triggeredFileInputId = null
    }
  }

  show() {
    this.modal.show()
  }
}
